import { component } from "picoapp";
import { TABBED_CAROUSEL_SETTINGS } from "../tbsp-carousel--constants";

export const tabbedCarousel = component(async (node) => {
  const [{ default: Splide }, { Intersection }] = await Promise.all([
    import("@splidejs/splide"),
    import("@splidejs/splide-extension-intersection"),
    // @ts-ignore
    import("@splidejs/splide/css/core"),
  ]);

  const splide = new Splide(node, TABBED_CAROUSEL_SETTINGS);

  splide.on("pagination:mounted", ({ list, items }) => {
    splide.Components.Slides.forEach(({ slide, index }) => {
      const name = slide.dataset.tabName || "";
      items[index].button.textContent = name;
    });

    list.classList.add("splide__pagination--tab");

    let dataSet = {
      mtrAs: "clickModule",
      mtrPosition: 0,
      mtrTarget: "tab",
      mtrTrack: "click",
    };

    items.forEach((item, idx) => {
      item.button.classList.add("splide__pagination__page--tab");
      item.li.classList.add("splide__pagination__page--tab_item");

      dataSet = {
        ...dataSet,
        mtrPosition: idx + 1,
      };

      Object.keys(dataSet).forEach((k) => {
        item.button.dataset[k] = dataSet[k];
      });
    });

    list.classList.remove("hidden");
  });

  splide.on("intersection:in", function (entry) {
    splide.on("active", ({ slide }) => {
      const video = slide.querySelector("video");

      if (video) {
        video.play().catch();
      }
    });

    splide.on("inactive", ({ slide }) => {
      const video = slide.querySelector("video");

      if (video) {
        video.muted = true;
        video.pause();
      }
    });

    node.querySelectorAll("video").forEach((video) => {
      video.preload = "auto";
    });
  });

  splide.mount({ Intersection });
});
